var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtlas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7eee2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3, .cls-5, .cls-8, .cls-10 {\n        stroke-width: 5px;\n      }\n\n      .cls-1, .cls-4, .cls-6, .cls-10 {\n        stroke: #5a6063;\n      }\n\n      .cls-11 {\n        fill: #aa4351;\n      }\n\n      .cls-12 {\n        fill: #ddc39e;\n      }\n\n      .cls-2 {\n        stroke-width: 1.1px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-13, .cls-8, .cls-9, .cls-10 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-7, .cls-14, .cls-9 {\n        stroke: #3f2d19;\n      }\n\n      .cls-15 {\n        fill: #dbcebf;\n      }\n\n      .cls-16 {\n        fill: #c9a983;\n      }\n\n      .cls-16, .cls-14 {\n        display: none;\n      }\n\n      .cls-17, .cls-18 {\n        fill: #443e3b;\n      }\n\n      .cls-3, .cls-13, .cls-8 {\n        stroke: #443e3b;\n      }\n\n      .cls-4, .cls-13 {\n        stroke-width: 2px;\n      }\n\n      .cls-19 {\n        fill: #4c0610;\n        opacity: .3;\n      }\n\n      .cls-19, .cls-18, .cls-20, .cls-21 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-22 {\n        fill: #dd5b62;\n      }\n\n      .cls-23 {\n        fill: #eae3dc;\n      }\n\n      .cls-18 {\n        opacity: .2;\n      }\n\n      .cls-24 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        stroke: #2d2c2b;\n      }\n\n      .cls-25 {\n        fill: #fece56;\n      }\n\n      .cls-20 {\n        opacity: .1;\n      }\n\n      .cls-26 {\n        fill: #93816c;\n      }\n\n      .cls-6 {\n        fill: #489645;\n      }\n\n      .cls-6, .cls-7, .cls-14 {\n        stroke-width: 3px;\n      }\n\n      .cls-27 {\n        fill: #d6cec8;\n      }\n\n      .cls-7, .cls-14 {\n        fill: #a3896d;\n      }\n\n      .cls-13 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-14 {\n        stroke-linejoin: bevel;\n      }\n\n      .cls-9 {\n        stroke-width: .9px;\n      }\n\n      .cls-21, .cls-28 {\n        opacity: .1;\n      }\n\n      .cls-28 {\n        fill: #333;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    id: "Couverture_Bas",
    className: "cls-10",
    points: "221.3 229.7 225.3 229.7 168.4 272.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Couverture_Couleur",
    className: "cls-22",
    points: "26.6 237.5 83.5 195.1 225.3 195.1 168.4 237.5 26.6 237.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Coin_2",
    className: "cls-25",
    points: "186.7 223.9 168.4 237.5 131.4 237.5 186.7 223.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Coin_1",
    className: "cls-25",
    points: "198 195.1 225.3 195.1 208.7 207.4 198 195.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Couverture_pli",
    className: "cls-11",
    points: "33.8 237.5 90.8 195.1 94 195.1 37 237.5 33.8 237.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ombre_carte",
    className: "cls-18",
    d: "M195.7,220.3c-17.3,1.3-38.8,2.1-62.1,2.1-34.9,0-66-1.7-84.9-4.4,0,.3,19.2-14.3,19.2-14.3,17.9-1.5,40.8-2.4,65.7-2.4s63.1,1.6,82.1,4.1l-20,14.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Couverture_Titre",
    className: "cls-19",
    points: "100 210.4 107.5 204.8 171.8 204.5 163.9 210.4 100 210.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Pages",
    className: "cls-1",
    x: 26.6,
    y: 237.5,
    width: 137.8,
    height: 37.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Pages_couleur_ombre",
    className: "cls-15",
    points: "221.3 197 164.4 239.5 164.4 275 221.3 232.6 221.3 197"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Pages_Ombres_2",
    className: "cls-28",
    points: "27.4 242.6 164.3 242.6 164.3 245 221.3 203.8 220.1 199.7 164.4 238.1 26.6 237.5 27.4 242.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Pages_Ombres",
    className: "cls-28",
    points: "164.5 265 27.4 250.9 164.3 251.7 221.3 211.2 221.3 223.9 164.4 257.4 164.5 265"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Pages_Coutour_2",
    className: "cls-10",
    points: "164.4 237.5 164.4 275 221.3 232.6 221.3 195.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Marque_page",
    className: "cls-6",
    points: "68.8 281.6 63.7 275 58.5 281.6 58.5 260.7 68.8 260.7 68.8 281.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page_Couleur",
    className: "cls-23",
    points: "221.1 209.2 164.3 251 26.6 251 158.4 258.7 236.3 209.3 221.1 209.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page_sombre",
    className: "cls-27",
    points: "164.4 254.9 236.3 209.3 221.1 209.2 164.3 251 164.4 254.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page_contour",
    className: "cls-4",
    points: "221.1 209.2 164.3 251 26.6 251 158.4 258.7 236.3 209.3 221.1 209.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Couverture_Contour",
    className: "cls-10",
    points: "26.6 237.5 83.5 195.1 225.3 195.1 168.4 237.5 26.6 237.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M247.7,154h20.3s-129.5,52-129.5,52h-9.8c0,0-15.8-4.1-15.8-4.1l.2-3c2.7-5.9,1.3-13.9,0-18.4s2.9-16.3,7.9-20.4,17.9-4.9,22.5,1.3,5.1,15.6,15.8,13.8,34.2-.9,37.3-7.6,2.2-14.4,11.6-17.6,27.3.4,27.3.4l12.3,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M199.4,96.1c.9-16.9,0-17.4,2.8-42-37.6,19-79.7,37.9-124.4,51.1,1.7,13.7-.8,22.9-2.9,38,47.6-16.9,79.3-28.1,124.5-47.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M37.7,114.6c7.1-3.4,37.2-24.5,37.2-24.5l-34.5-25.1s-6.7.8-19.9,8.3-12.9,21.5-10,28,21,16.4,27.3,13.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 37.1,
    y1: 112.3,
    x2: 73,
    y2: 89.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Curl_Contour",
    className: "cls-3",
    d: "M21.3,72.9c-13.6,9.6-15.7,18.9-10.3,29.8s16.1,12.5,22.5,11,11.6-10.4,6.8-19.5c-4.2-7.9-14.2-6.2-16.1-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Feuille_Fond",
    className: "cls-12",
    d: "M268,154c-26.3,5.9-52.1-12.1-62.2-33.2-15.6-32.5,3-53.6-5.9-75-8.9-21.3-31.4-30.8-56.3-24.6L21.2,73.1c24.9-6.2,45.3,2.5,54.2,23.9s-9.6,42.4,5.9,75c10.1,21,35.9,39.1,62.2,33.2l124.4-51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Continent",
    className: "cls-7",
    d: "M77.5,165.2c-1.5-8.9-4.3-17.4-2.7-26.2,3-16,3.9-32.3,0-43.3s-9.6-12.6-18.7-20c-2.5-2-12.6-5-15.6-6.1-5.5-2-13.4,1.8-19.2,2.2l25.6-9.7c6.9,2.4,11.8-1.9,18.8-4,7.7-2.3,15.8-3.6,23.8-3.8,2.4,0,5.8,1,5.3,3.4-.4,2.3-4.3,3-4.2,5.4,2.2,1.2,4.8,1.7,7.3,1.6,0-2.7,2.3-4.9,4.9-5.8s5.3-.8,8-.7c-.3,2.1,2.2,3.6,4.3,3.4s4-1.3,6.1-1.5c5.4-.7,10.3,5.7,8.1,10.7-1.9,4.4-7.4,6.3-9.4,10.6-2.3,4.8,1.5,11.3,6.8,11.6,1.8,4-.2,8.8-3,12.2s-6.4,6.3-8.4,10.2c-1.9,3.8-2.2,8.2-2.1,12.5,0,2,.1,4.2,1.2,5.9.8,1.2,2,2.1,2.9,3.2,4,4.9,1.1,12.9,4.8,18.1,2.8,3.9,8.3,4.6,13.1,4.5s10-.8,14.2,1.5c3.5.8,6.1,11.9,11.4,15.7,3.5,3.9-2.5,19-9.5,24.8-2.1,1.7-4.8,2.4-7.4,2.8-8.6,1.5-17.4,1.2-25.9-.8-5.7-1.4-11.4-3.6-15.4-7.8-2.3-2.4-9.4-6.2-11.7-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ile_1",
    className: "cls-7",
    d: "M153.9,142.8c.7,0,1.4,0,2,.3,1,.5,1.4,1.7,1.5,2.8s-.2,2.2-.2,3.3c.1,2,1.3,3.8,3.1,4.7s4,.8,5.6-.2c1.2-.7,2-1.8,3.2-2.5,1.6-1,3.7-1.1,5.4-.4,1.9.8,3.5,2.7,5.6,2.7,2.4,0,3.9-2.7,4.6-5,.2-.7.4-1.5,0-2.2-.2-.6-.8-1-1.4-1.3-2.2-1.2-4.8-1.3-7.3-1.5-1,0-2-.1-2.8-.7-.7-.4-1.1-1.1-1.6-1.7-3-3.9-7.1-6.7-11.2-9.4-.9-.6-1.8-1.2-2.8-1.3-6-1.1-11.7,11.3-3.8,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ile_2",
    className: "cls-7",
    d: "M133.6,131.7c.1,1.7,2.5,10.6,4.4,6.8s.4-3.9.1-4.6q-.4-1.2-1.6-1.7c-.4-.2-2.9-.2-2.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Feuille_Ombre",
    className: "cls-21",
    d: "M199.4,96.1c.9-16.9,0-17.4,2.8-42-37.6,19-79.7,37.9-124.4,51.1,1.7,13.7-.8,22.9-2.9,38,47.6-16.9,79.3-28.1,124.5-47.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Feuille_Bordure"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M268,154c-26.3,5.9-52.1-12.1-62.2-33.2-15.6-32.5,3-53.6-5.9-75-8.9-21.3-31.4-30.8-56.3-24.6L21.2,73.1c16-11.1,45.3,2.5,54.2,23.9s-9.6,42.4,5.9,75c10.1,21,35.9,39.1,62.2,33.2l124.4-51.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vagues"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.9,57.4c2.1-5,8,1.5,10.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.3,62c2.1-5,8,1.5,10.1-2.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vagues-2",
    "data-name": "Vagues"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145,103.5c2.1-5,8,1.5,10.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.4,108.1c2.1-5,8,1.5,10.1-2.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vagues-3",
    "data-name": "Vagues"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.6,118.4c2.1-5,8,1.5,10.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177,123c2.1-5,8,1.5,10.1-2.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vagues-4",
    "data-name": "Vagues"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.2,43.7c2.1-3.1,8,.9,10.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.7,46.5c2.1-3.1,8,.9,10.1-1.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vagues-5",
    "data-name": "Vagues"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.7,167.1c2.1-3.1,8,.9,10.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M178.1,170c2.1-3.1,8,.9,10.1-1.8"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M125.7,223.4c-2.9,2.9-10.9,5.2-17.8,5.2s-10.3-2.3-7.4-5.2,10.9-5.2,17.8-5.2,10.3,2.3,7.4,5.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "121.7 214.8 118.8 221.7 133.8 223.4 115.4 225.1 104.5 232 107.3 225.1 92.3 223.4 110.7 221.7 121.7 214.8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlas);
export default __webpack_public_path__ + "static/media/atlas.4a30d963a6de02fd304488bbb8f3fa98.svg";
export { ForwardRef as ReactComponent };